module.exports = __webpack_public_path__ + "static/media/Nocturne.8e6827b2.png";